export default "__VITE_ASSET__Bpv3NI3e__"